import { Card } from "react-bootstrap"

interface Props {
    data: any;
}

export const TransactionDetailsUI = (props: Props) => {
    return (
        <Card className='box-shadow rounded-4 '>
            <Card.Body className='py-2'>
                <div className="row text-center d-none d-md-flex d-lg-flex">
                    {props?.data?.length > 0 &&
                        props.data.map((item: any, index: number) => (
                            <div key={index} className={`col-md-4 my-2 ${index === props?.data?.length- 1 ? "" : "light-grey-right-border"}`}>
                                <h6 className="mb-0">{item?.header}</h6>
                                <span>{item?.value}</span>
                            </div>
                        ))}
                </div>
                {props?.data?.length > 0 &&
                    props.data.map((item: any, index: number) => (
                        <div key={index} className="row d-flex align-items-center fs-14 d-md-none d-lg-none mb-1">
                            <div className="col-3 fw-semibold pe-0">{item?.header}</div>
                            <div className="col-9 text-start">: {item?.value}</div>
                        </div>
                    ))}

            </Card.Body>
        </Card>
    )
}